// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { createTheme } from '@mantine/core'

export const theme = createTheme({
  // Primary brand colors - Teal/Turquoise
  colors: {
    // Primary - Teal/Turquoise
    primary: [
      '#e6faf9', // primary-50
      '#ccf5f2', // primary-100
      '#99ebe6', // primary-200
      '#66e0d9', // primary-300
      '#33d6cd', // primary-400
      '#0abab5', // primary-500
      '#13a89e', // primary-600
      '#0e7e78', // primary-700
      '#095552', // primary-800
      '#042b29', // primary-900
    ],

    // Secondary - Light Blue
    secondary: [
      '#f0f9ff', // secondary-50
      '#e0f2fe', // secondary-100
      '#bae6fd', // secondary-200
      '#7dd3fc', // secondary-300
      '#38bdf8', // secondary-400
      '#0ea5e9', // secondary-500
      '#0284c7', // secondary-600
      '#0369a1', // secondary-700
      '#075985', // secondary-800
      '#0c4a6e', // secondary-900
    ],

    // Neutral/Gray
    neutral: [
      '#f5f7fb', // neutral-50
      '#ebeef0', // neutral-100
      '#e0e0e0', // neutral-200
      '#c8c8c8', // neutral-300
      '#95989d', // neutral-400
      '#808184', // neutral-500
      '#606367', // neutral-600
      '#3c3e3d', // neutral-700
      '#202124', // neutral-800
      '#111111', // neutral-900
    ],

    // Success - Green
    success: [
      '#ecfdf5', // success-50
      '#d1fae5', // success-100
      '#a7f3d0', // success-200
      '#6ee7b7', // success-300
      '#34d399', // success-400
      '#10b981', // success-500
      '#059669', // success-600
      '#047857', // success-700
      '#065f46', // success-800
      '#064e3b', // success-900
    ],

    // Warning - Yellow/Amber
    warning: [
      '#fffbeb', // warning-50
      '#fef3c7', // warning-100
      '#fde68a', // warning-200
      '#fcd34d', // warning-300
      '#fbbc05', // warning-400
      '#f59e0b', // warning-500
      '#d97706', // warning-600
      '#b45309', // warning-700
      '#92400e', // warning-800
      '#78350f', // warning-900
    ],

    // Error - Red
    error: [
      '#fef2f2', // error-50
      '#fee2e2', // error-100
      '#fecaca', // error-200
      '#fca5a5', // error-300
      '#f87171', // error-400
      '#ea4335', // error-500
      '#dc2626', // error-600
      '#b91c1c', // error-700
      '#991b1b', // error-800
      '#7f1d1d', // error-900
    ],

    'ink-dark': ['#252A31'],
    normal: ['#4F5E71'],
    'brand-dark': ['#0C756E'],
    'brand-light': ['#E8F9F8'],
    'cloud-normal': ['#E8EDF1'],
  },

  // Set primary color to our primary (teal/turquoise)
  primaryColor: 'primary',

  // Default radius for components
  defaultRadius: 'md',

  // Font settings
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',

  // Headings configuration
  headings: {
    fontFamily: 'inherit',
    fontWeight: '600',
    sizes: {
      h1: { fontSize: '2.25rem', lineHeight: '2.5rem' },
      h2: { fontSize: '1.875rem', lineHeight: '2.25rem' },
      h3: { fontSize: '1.5rem', lineHeight: '2rem' },
      h4: { fontSize: '1.25rem', lineHeight: '1.75rem' },
      h5: { fontSize: '1.125rem', lineHeight: '1.75rem' },
      h6: { fontSize: '1rem', lineHeight: '1.5rem' },
    },
  },

  // Shadows
  shadows: {
    xs: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    sm: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  },

  // Other customizations
  other: {
    // Custom properties that can be used in your app
    appShell: {
      header: {
        height: 60,
      },
      navbar: {
        width: {
          collapsed: 80,
          expanded: 250,
        },
      },
    },
  },

  // Component
  components: {
    Text: {
      defaultProps: {
        color: 'ink-dark.0',
      },
    },
    Button: {
      defaultProps: {
        color: 'brand-dark.0',
      },
    },
    Stack: {
      defaultProps: {
        shadow: 'none',
      },
    },
    Input: {
      classNames: {
        input: 'data-[error=true]:!text-[#252A31]',
      },
    },
    PasswordInput: {
      classNames: {
        innerInput: 'data-[invalid=true]:!text-[#252A31]',
      },
    },
  },
})
